/* eslint-disable dot-notation */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AppendDomainPipe } from '../../pipes/append-domain-name.pipe';

export interface IUserCard {
  id: string;
  name: string;
  position: string;
  roles: string;
  profilePictureUrl: string;
}

@Component({
  selector: 'app-user-card',
  standalone: true,
  imports: [TranslateModule, MatMenuModule, MatIconModule, AppendDomainPipe],
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCardComponent {
  @Input() set user(user: any) {
    this.userCard = this.getUserCard(user);
  }
  @Input() showMenu = true;
  @Input() wrap = true;
  userCard: IUserCard;

  private getUserCard(user: any): IUserCard {
    return {
      id: user?.userId || user?.id,
      name:
        user?.userName || user?.name || user?.fullName || `${user?.firstName} ${user?.lastName}`,
      position: user?.positionName || user?.jobPosition || user?.employedAs,
      roles: user?.roles?.join(', ') || '',
      profilePictureUrl: user?.profilePicture?.link || user?.profilePictureUrl || '',
    };
  }
}
